import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const manageNotificationDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createNotification',
        popover: {
          title: 'Create New Notification',
          description:
            'Use this feature to create a new notification. You can customize the message, audience, and timing to ensure effective communication.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.bannerNotification',
        popover: {
          title: 'Manage Banner Notifications',
          description:
            'This section allows you to create and manage banner notifications that appear at the top of the user interface. These are useful for important announcements.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.changeLogNotification',
        popover: {
          title: 'Change Log Notifications',
          description:
            'Here you can create notifications specifically related to change logs. Keep users informed about updates and changes within the system.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.editBanner',
        popover: {
          title: 'Edit Banner Notification',
          description:
            'Use this option to edit an existing banner notification. You can update the content and settings to reflect current needs.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deleteBanner',
        popover: {
          title: 'Delete Banner Notification',
          description:
            'Remove an existing banner notification that is no longer needed. Be sure to confirm before deletion, as this action is irreversible.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.notificationMainTableData',
        popover: {
          title: 'Notifications Overview',
          description:
            'This table provides an overview of all notifications created within the system. You can view, edit, or delete notifications as needed.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default manageNotificationDriverObj;
